import React, { useEffect, useState } from 'react'
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateTime } from "luxon";
import { useDetectClickOutside } from 'react-detect-click-outside';
import { DATE_FORMAT_SERVER, DATE_FORMAT_DISPLAY } from '../../constants';
import { ErrorMessage } from 'formik';
import { calanderLocale } from '../../utils';

import DatePicker from 'react-date-picker';

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

import { IoMdClose } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";

const DateField = ({ form, field, label_text, placeholder, isDisabled, maxDate, minDate, isStart, end_field, isRequired }) => {

    const [show, setShow] = useState(false);

    // close calender if clicked outside calender
    const ref = useDetectClickOutside({ onTriggered: () => setShow(false) });

    const handleChange = (value) => {
        // reset end date if we are setting start date
        if (isStart) {
            form.setFieldValue(end_field, "")
        }
        form.setFieldValue(field, DateTime.fromJSDate(value).toFormat(DATE_FORMAT_SERVER, DATE_FORMAT_DISPLAY))
        setShow(false);
    }

    let locale = calanderLocale();

    // ==========================================================================
    // const [value, onChange] = useState(form.values[field]);
    const [value, onChange] = useState(form.values[field] ? DateTime.fromISO(form?.values[`${field}`]).toJSDate() : "");

    const [error, setError] = useState(false);
    const [fieldFocus, setFieldFocus] = useState(false);

    const handleDateChange = (value) => {
        if (value === null) {
            // Handle clearing the date
            form.setFieldValue(field, "")
            if (isStart) {
                form.setFieldValue(end_field, "")
            }
        } else {
            // Handle setting the date
            if (isStart) {
                form.setFieldValue(end_field, "")
            }
            form.setFieldValue(field, DateTime.fromJSDate(value).toFormat(DATE_FORMAT_SERVER));
        }
        setShow(false);
    }


    useEffect(() => {
        if (value) {
            handleDateChange(value)
        }
    }, [value])

    return (
        <>
            <div className='relative' ref={ref}>
                {show &&
                    <Calendar
                        color="#000"
                        className="absolute top-0 left-0 z-[25] shadow-xl"
                        onChange={handleChange}
                        date={form.values[field] ? DateTime.fromISO(form.values[field]).toJSDate() : new Date()}
                        minDate={minDate}
                        maxDate={maxDate}
                        locale={locale}
                    />
                }
                <label htmlFor="fname" className={`text-xs font-medium inline-block`}>{label_text}{isRequired && <span className=''>*</span>}</label>
                <div className='relative'>

                    <input
                        autoComplete='off'
                        value={form.values[field] ? DateTime.fromISO(form.values[field]).toFormat(DATE_FORMAT_DISPLAY) : form.values[field]}
                        onFocus={() => setShow(true)}
                        placeholder={placeholder ? placeholder : ""}
                        name={field}
                        id={field}
                        disabled={isDisabled}
                        className={`h-[45px] !rounded-[7px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${form.touched[field] && form.errors[field] ? "input-text-error" : ""} ${form.values[field] && form.values[field].toString().length > 0 && "input-text-active"}`}
                    />
                    <IoCalendarOutline onClick={() => setShow(true)} className={`text-gray-500 ${form.touched[field] && form.errors[field] ? "text-red-500" : ""} ${form.values[field] && form.values[field].toString().length > 0 && "text-emerald-500"} absolute top-2/4 right-4 translate-y-[-50%]`} />
                </div>
                <p className="text-xs text-red-500">
                    <ErrorMessage name={field} />
                </p>
            </div>

            {/* ====================================================== */}

            {/* <div className='relative' ref={ref}>
                <label htmlFor="fname" className={`text-sm font-medium mb-3 inline-block`}>{label_text}</label>
                <div className='relative'>

                    <DatePicker
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        value={value}
                        // value={DateTime.fromISO(value).toJSDate()}
                        // value={form.values[field]}
                        minDate={minDate}
                        maxDate={maxDate}
                        onChange={onChange}
                        // onChange={(date) => {
                        //     handleDateChange(date);
                        //     setShow(false);
                        // }}
                        // clearIcon={null}
                        // disableCalendar={form.values[field] ? true : false}
                        clearIcon={form.values[field] && <IoMdClose
                            onClick={() => {
                                setShow(false)
                                form.setFieldValue(field, "")
                            }}
                            className={`flex-shrink-0 text-xl text-gray-500 ${form.values[field] && "text-primary"} cursor-pointer`}
                        />}
                        format={DATE_FORMAT_DISPLAY}
                        onFocus={() => setFieldFocus(true)}
                        onBlur={() => setFieldFocus(false)}
                        // onInvalidChange={() => {
                        //     // setError(true)
                        //     // form.setFieldError(field, true)
                        // }}
                        className={`h-[45px] pt-[10px] z-30 w-full resize-none rounded-[10px] border-2 py-2 px-2 ${fieldFocus ? "border-2 border-primary" : "border-gray-200"} ${(error || form?.errors[field]) && "!border-red-500"}`}
                    />
                </div>

                <p className="text-xs text-red-500">
                    <ErrorMessage name={field} />
                </p>
            </div> */}
        </>
    )
}

export default DateField